import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import axios from 'axios'
import Clipboard from 'v-clipboard'
import './assets/global.css';
import i18n from './i18n'

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,

  created() {
    console.log(`[MAIN] - created... `);

    // I18N - check and set the locale
    const locale = localStorage.getItem('locale-admin');
    if (locale) this.$i18n.locale = locale;

    // check if user object already exists on sessionStorage. used when reload the browser tab
    const userString = sessionStorage.getItem('user')
    // console.log(`[MAIN] - userString: `, userString)
    if (userString) {
      const userData = JSON.parse(userString)
      // console.log(`[MAIN] - userData: `, userData)
      this.$store.dispatch('users/setUserData', userData)
    }

    axios.interceptors.response.use(
      response => {
        this.$store.commit('users/SET_SHOW_SPINNER', false);
        return response
      },
      error => {
        this.$store.commit('users/SET_SHOW_SPINNER', false);
        if (error.response.status === 400
          && error.response.data
          && error.response.data.message == 'JWT_VERIFICATION_FAILED'
        ) {
          console.log(`[main] - created - 400 && JWT_VERIFICATION_FAILED`)
          
          if (userString) {
            const setSnackObj = {
              // message: 'Your session has expired! You will be logged out in few seconds...',
              message: i18n.t('message.error.sessionExpired'),
              isError: true,
              isBlocked: true
            }
            console.log(`[main] - created - 400 && JWT_VERIFICATION_FAILED - setSnackObj; `, setSnackObj)
            
            store.dispatch('setSnack', setSnackObj);

            setTimeout(() => {
              store.dispatch('users/logout')
            }, 2000);
          } else {
            const setSnackObj = {
              message: i18n.t('message.error.resetPasswordSessionExpired'),
              isError: true,
              isBlocked: true
            }
            console.log(`[main] - created - 400 && JWT_VERIFICATION_FAILED - setSnackObj; `, setSnackObj)
            
            store.dispatch('setSnack', setSnackObj);

            setTimeout(() => {
              router.push({ name: 'login' });
            }, 2000);
          }
      
        }
        return Promise.reject(error)
      }
    )

  /*
  * The interceptor here ensures that we check for the token in sessionStorage every time an ajax request is made
  */
    axios.interceptors.request.use(
      (config) => {
        // Set request headers for only same origin
        let crossDomainReq = sessionStorage.getItem('cross-domain-request');
        let accessToken;

        if (!crossDomainReq) {
          store.commit('users/SET_SHOW_SPINNER', true);
          accessToken = sessionStorage.getItem('accessToken');
        }

        if (accessToken) {
          // config.headers['Authorization'] = `Bearer ${accessToken}`;
          config.headers['Content-Type'] = `application/json`;
          config.headers['x-access-token'] = accessToken;
        }

        return config;
      },

      (error) => {
        store.commit('users/SET_SHOW_SPINNER', false);
        return Promise.reject(error);
      }
    );
  },

  i18n,
  render: h => h(App)
}).$mount('#app')

Vue.use(Clipboard)
